module.exports = require("@mui/icons-material/FormatAlignRight");